import React, { useEffect, useState } from "react";
import LabData from '../../../../globalcomponents/patient360/medicalhistory/labData'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
const PatientLabdata = (props) => {
  return (
    <>
      <LabData data={props.formValues.patientdata} app="Site" />
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    formValues: state.form,
    state
  }
}

export default withRouter(connect(mapStateToProps, null)(PatientLabdata));

